module.exports = __webpack_public_path__ + "img/nido.b6656870.png";